export const SELECT_PRODUCT_UPDATE_REQUESTED = 'SELECT_PRODUCT_UPDATE_REQUESTED';
export const SELECT_PRODUCT_UPDATE_COMPLETED = 'SELECT_PRODUCT_UPDATE_COMPLETED';
export const SELECT_PRODUCT_UPDATE_ERROR = 'SELECT_PRODUCT_UPDATE_ERROR';
export const SELECT_PRODUCT_RESET_REQUESTED = 'SELECT_PRODUCT_RESET_REQUESTED';
export const SELECT_PRODUCT_RESET_COMPLETED = 'SELECT_PRODUCT_RESET_COMPLETED';
